<card name="Tooltips">
  <div card content>
    <div class="row">
      <div class="col-20">
        <div class="form-group">
          <label class="form-label" for="tooltip1">Подсказка</label>
          <input id="tooltip1" type="text" class="form-control" placeholder="Tooltip"
                 popper="Добрый день"
                 popperApplyClass="popper-opacity-info"
                 [popperTrigger]="'none'">
        </div>
      </div>

      <div class="col-20">
        <div class="form-group">
          <label class="form-label" for="tooltip2">Ошибка</label>
          <input id="tooltip2" type="text" class="form-control" placeholder="Tooltip"
                 popper="Добрый день"
                 popperApplyClass="popper-opacity-danger"
                 [popperShowOnStart]="true"
                 [popperTrigger]="'hover'">
        </div>
      </div>

      <div class="col-20">
        <div class="form-group">
          <label class="form-label" for="tooltip3">Успех</label>
          <input id="tooltip3" type="text" class="form-control" placeholder="Tooltip"
                 popper="Добрый день" popperApplyClass="popper-opacity-success" [popperTrigger]="'hover'">
        </div>
      </div>

      <div class="col-20">
        <div class="form-group">
          <label class="form-label" for="tooltip4">Внимание</label>
          <input id="tooltip4" type="text" class="form-control" placeholder="Tooltip"
                 popper="Добрый день" popperApplyClass="popper-opacity-warning" [popperTrigger]="'hover'">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-20">
        <div class="form-group">
          <label class="form-label" for="tooltip-1">Большая</label>
          <input id="tooltip-1" type="text" class="form-control form-control-lg" placeholder="Tooltip"
                 popper="Добрый день" [popperTrigger]="'hover'">
        </div>
      </div>

      <div class="col-20">
        <div class="form-group">
          <label class="form-label" for="tooltip-2">Средняя</label>
          <input id="tooltip-2" type="text" class="form-control" placeholder="Tooltip"
                 popper="Добрый день"
                 [popperShowOnStart]="true"
                 popperAppendTo="body"
                 [popperHideOnClickOutside]="false"
                 [popperTrigger]="'none'">
        </div>
      </div>

      <div class="col-20">
        <div class="form-group">
          <label class="form-label" for="tooltip-3">Маленькая</label>
          <input id="tooltip-3" type="text" class="form-control form-control-sm" placeholder="Tooltip"
                 popper="Добрый день" [popperTrigger]="'hover'">
        </div>
      </div>
    </div>
  </div>
</card>
